"use client";
import { usePathname, useRouter } from "@/i18n/routing";
import { cn, RadioGroup } from "@heroui/react";
import _ from "lodash";
import { useLocale, useTranslations } from "next-intl";
import LanguageRadio from "@/components/lang-radio";

const LanguageModal = () => {
  const t = useTranslations();
  const pathname = usePathname();
  const router = useRouter();
  const locale = useLocale();
  return (
    <div className="flex size-full h-24 flex-col items-center justify-center text-center">
      <RadioGroup
        aria-label="payment-method"
        className="w-full"
        classNames={{
          wrapper: cn("grid grid-cols-2 gap-4"),
          label: cn("bg-zinc-700")
        }}
        value={locale}
        onValueChange={(value) => router.replace(pathname, { locale: value })}
      >
        <LanguageRadio value="en-bd">
          <div className="text-tiny">
            <span className="fi fi-gb" /> <span className="ms-2">{t("English")}</span>
          </div>
        </LanguageRadio>
        <LanguageRadio value="bn-bd">
          <div className="text-tiny">
            <span className="fi fi-bd" /> <span className="ms-2">{t("Bengali")}</span>
          </div>
        </LanguageRadio>
      </RadioGroup>
    </div>
  );
};

export default LanguageModal;
